export const OFFER_ID_COOKIE = 'promoOfferId';
